import React from 'react';
import classNames from 'classnames/bind';
import { Typography } from 'gd-design-library';
import { ImageTransformation, ProductDetailsBannerItem } from '@services';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsBannerItem;
}

export const Banner: React.FC<Props> = ({
  productDetailsItem: {
    banner: {
      title,
      image
    }
  }
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(productDetailsItemClassName) }>
      <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
        {title}
      </Typography>
      <img src={ imageTransformation.transformById(
        image[0].public_id,
        ALL_IMAGES_TRANSFORMATIONS
      ) } />
    </div>
  );
};
